import { useConfirmationDialog } from '@justomx/atlas-components'
import { useNavigate } from 'react-router-dom'

import { useRequiredParams } from 'hooks/params.hook'
import { useRegisterProduct } from 'hooks/registerProduct.hook'

export const useScanLocation = () => {
  const navigate = useNavigate()
  const { container } = useRequiredParams('container')
  const { open, dialogRef } = useConfirmationDialog()

  const { register, loading } = useRegisterProduct()

  const handleScanLocation = (scanned: string) => {
    register(container, scanned)
  }

  const onGoBack = () => {
    navigate(-1)
  }

  const openKeyboard = () => {
    open()
  }

  return {
    container,
    dialogRef,
    loading,
    actions: { onGoBack, handleScanLocation, openKeyboard }
  }
}
